@import '../../../globals/main.scss';

pn-spotlight .pn-spotlight__container:has(pn-parcel-tracker) {
  [slot='mobile-heading'] {
    color: $blue700;
  }
}

.pn-spotlight__container__wrapper__content [slot='content']:has(pn-parcel-tracker) {
  padding-left: 2rem;
}

pn-parcel-tracker {
  width: 100%;

  .pn-parcel-tracker__container {
    form {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      gap: 1.6rem;

      .pn-parcel-tracker__container__heading {
        color: $blue700;
        font-weight: 500;
        margin-bottom: 0;

        @media screen and (max-width: $min-width-md) {
          display: none;
        }

        @media screen and (min-width: $min-width-xxl) {
          font-size: 2.4rem;
          font-weight: 700;
        }
      }

      pn-marketweb-input {
        flex-grow: 1;
        max-width: 80%;

        @media screen and (min-width: $min-width-sm) {
        }

        @media screen and (min-width: $min-width-md) {
          max-width: 50%;
        }

        @media screen and (min-width: $min-width-lg) {
          max-width: 45%;
        }

        @media screen and (min-width: $min-width-xxl) {
          max-width: 35%;
        }

        input {
          border-radius: 6.4rem;
        }
      }
    }
  }
}
